export const AvgVideosReviewedGraph = () => {
  return <div>Chart coming soon...</div>;
};
